import React, { Fragment, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { Input, Progress, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import Card from "../../../../components/bootstrap/card";
import { resetUserPasswordService } from "../../../../services/UserService";

const ResetPassword = ({ show, handleClose, userData }) => {
  const [newPassword, setNewPassword] = useState("");
  const [strength, setStrength] = useState(0);
  const [passwordError, setPasswordError] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const validatePassword = password => {
    const rules = [
      /.{11,}/,
      /[a-z]/,
      /[A-Z]/,
      /\d/,
      /[!@#$%^&*()_\-+={}[\]|:;"'<>,.?/]/
    ];

    const passed = rules.filter(r => r.test(password)).length;
    setStrength((passed / rules.length) * 100);

    if (passed === rules.length) {
      setPasswordError("");
      setIsPasswordValid(true);
    } else {
      setPasswordError(
        "Password must be at least 11 characters long and include uppercase, lowercase, number, and special character."
      );
      setIsPasswordValid(false);
    }
  };

  const generatePassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "!@#$%^&*()_-+={}[]|:;\"'<>,.?/";
    

    let password = "";
    // make sure it contains one of each (uppercase, lowercase, number, symbols)
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    // Fill the rest randomly to make it at least 11 characters
    while (password.length < 11) {
       const allChars = uppercase + lowercase + numbers + symbols;
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    // Shuffle the password to avoid predictable pattern
    password = password.split('').sort(() => 0.5 - Math.random()).join('');

    setNewPassword(password);
    validatePassword(password);
  };

  const resetPassword = async () => {
    try {
      const token = localStorage.getItem("token");
      await resetUserPasswordService( userData.signal_users_id, newPassword, token );

      message.success("Password reset successfully");
      handleClose();
    } catch {
      message.error("Failed to reset password");
    }
  };

  return (
    <Fragment>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Body>
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Reset User Password</h4>
              </div>
            </Card.Header>

            <Card.Body>
              <Form>
                <Form.Group className="col-md-12 form-group">
                      <Form.Label htmlFor="fullname">Full Name</Form.Label>
                      <Form.Control type="text" value={userData.fullname} id="fullname" placeholder="FullName" disabled />
                </Form.Group>

                <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="email">Email</Form.Label>
                    <Form.Control type="email" value={userData.email} id="email" placeholder="Email" disabled />
                  </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <div className="d-flex gap-2">
                    <Input.Password
                      value={newPassword}
                      onChange={e => {
                        setNewPassword(e.target.value);
                        validatePassword(e.target.value);
                      }}
                      iconRender={v =>
                        v ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                      status={passwordError ? "error" : ""}
                    />

                    <Button style={{fontSize: '0.90rem', width: '45%'}} type="button" onClick={generatePassword}>
                      Auto-generate
                    </Button>
                  </div>

                  <Progress
                    percent={strength}
                    showInfo={false}
                    strokeColor={
                      strength < 60 ? "red" : strength < 80 ? "orange" : "green"
                    }
                    className="mt-2"
                  />

                  {passwordError && (
                    <div className="text-danger mt-1">{passwordError}</div>
                  )}
                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button variant="secondary" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={resetPassword}
                    disabled={!isPasswordValid}
                  >
                    Update
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ResetPassword;
